import { Col } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useIssueFindingsDrawer } from "@/organisms/Drawers/applications/triage/useTriage"
import { IntroducedThroughCard } from "./components/IntroducedThroughCard/IntroducedThroughCard"
import { RemediationCard } from "./components/RemediationCard"

import type { PackageVulnerabilityCardsProps } from "."

export const PackageVulnerabilityCards = ({
  record,
  classNameCol
}: PackageVulnerabilityCardsProps) => {
  const { t } = useTranslation()
  const tKey = "inventory.images.drawer.issue."
  const context = useIssueFindingsDrawer(record.id)
  const { response, isLoading } = context

  return (
    <>
      <Col span={24} className={classNameCol}>
        <RemediationCard
          t={t}
          tKey={tKey}
          isLoading={isLoading}
          response={response}
        />
      </Col>
      {record && (
        <Col span={24} className={classNameCol}>
          <IntroducedThroughCard
            t={t}
            tKey={tKey}
            isLoading={isLoading}
            response={response}
          />
        </Col>
      )}
    </>
  )
}
